exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.no-connection{\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    z-index: 1000;\n    background-color: #ccc;\n    opacity: 0.5;\n    text-align: center;\n}\n.no-connection img {\n    max-width: 100%;\n    max-height: 100%;\n}\n\n\n", ""]);

// exports
